import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import routes from 'store/configs/Routes';
import { Auth0Service } from 'services/Auth0Service';
import SignInLink from 'components/shared/SignInLink';

import './TopBarComponent.scss';

interface Props {
  extraClasses?: string;
  hideLogin?: boolean;
}

const TopBarComponent: React.FC<Props> = ({ extraClasses = '', hideLogin = false }) => {
  const [isLoggedIn, setIsLoggedIn] = useState<boolean | null>(null);

  useEffect(() => {
    Auth0Service.isLoggedIn().then((loggedIn) => setIsLoggedIn(loggedIn));
  }, []);

  return (
    <div id="topBarComponent" className={`w-100 ${extraClasses}`}>
      <ul className="navbar-nav d-md-inline-block float-md-right">
        <li>
          <a className="nav-link py-md-0" href="https://store-us.semi.org/cart">
            Cart
          </a>
        </li>
        <li>
          <a
            className="nav-link py-md-0"
            href="https://www.semi.org/en/resources/library?search=&start=&end=&membership%5Bmember%5D=member&sort_bef_combine=created_DESC&sort_bef_combine=created_DESC"
          >
            Members Only
          </a>
        </li>
        {!hideLogin && isLoggedIn === false && (
          <li>
            <SignInLink className="nav-link py-md-0">Sign In</SignInLink>
          </li>
        )}
        {!hideLogin && isLoggedIn === true && (
          <li>
            <Link className="nav-link py-md-0" to={routes.logout}>
              Sign Out
            </Link>
          </li>
        )}
      </ul>
    </div>
  );
};

export default TopBarComponent;
